import { API } from "@/lib/api";
import { WriteInvoiceSpecificationStores } from "@/schemas/invoiceSpecificationForm";
import { ReadLaborCostsInStoresRoleBased } from "@/schemas/laborCostsInStores";
import { APIService, FetchListRequest } from "@/services/api";

const LaborCostsInStoresRoleBasedServiceAPI =
  new APIService<ReadLaborCostsInStoresRoleBased>(API.InvoiceSpecifications);

export const laborCostsInStoresRoleBased = {
  getList: (
    settlementId: string,
    fetchParams?: FetchListRequest<ReadLaborCostsInStoresRoleBased>,
  ) =>
    LaborCostsInStoresRoleBasedServiceAPI.getList(
      fetchParams,
      `/${settlementId}/stores`,
    ),
  patch: (
    invoiceSpecificationId: string,
    values: WriteInvoiceSpecificationStores,
  ) =>
    LaborCostsInStoresRoleBasedServiceAPI.patch(invoiceSpecificationId, values),
};
